{ get_from_list } = require('../../utils')

module.exports = ($scope, countries, subject, User, heimdallClassifications, Api) ->
  $scope.countries = ({ id: c.iso_code, name: c.name } for c in countries)
  $scope.subject = subject
  $scope.user = User

  $scope.classifications = heimdallClassifications
  $scope.tagsFilter = [{name: "See all"}].concat(User.alerts_tagging_config?.tags or [])

  #
  # Tagging toolbar
  #

  $scope.saveTags = (alert, tagIds) ->
    ignore = new Api.MonitoringSubjectAlerts id: alert.id, subject: alert.subject, tags: tagIds or []
    ignore.$update()
    alert.tags = tagIds
    return

  $scope.isDisabled = (alert) ->
    # To be implemented
    false

  $scope.getTaggingConfig = () ->
    User.alerts_tagging_config

  $scope.getAlertsTags = () ->
    $scope.getTaggingConfig()?.tags or []

  #
  # View helpers
  #

  $scope.dobPrecisionHashMap =
    "3Y": "± 3 years"
    "2Y": "± 2 years"
    "1Y": "± 1 year"
    "Y": "Given year"
    "M": "Given year and month"
    "D": "Given year, month, day"

  $scope.precisionHashMap =
    "D": "Day"
    "M": "Month"
    "W": "Week"
    "M": "Month"
    "Q": "3 months"
    "2Q": "6 months"
    "Y": "Year"
    "2Y": "2 years"
    "3Y": "3 years"

  $scope.getSubjectName = (subject) ->
    components = []
    if subject.first_name
      components.push(subject.first_name)
    if subject.middle_name
      components.push(subject.middle_name)
    if subject.last_name
      components.push(subject.last_name)
    return components.join(' ')

  $scope.getFullName = (alert) ->
    return unless alert?.data?

    # Old Anansi name structure (uses `name_details` field)
    if alert.data.name_details?
      name = alert.data.name_details[0]
    # New Anansi name structure (uses `names` field, and incl. name type)
    # Returns the display name
    else
      primary_names = (name for name in alert.data.names when name.name_type?.toLowerCase() == 'primary name')
      name = primary_names[0]?.full_name
      if not name
        name = alert.data.names[0]?.full_name
      name = name[0] if typeof name is 'object'
    return name

  $scope.getDOB = (alert) ->
    return alert.data['DOB'] if alert.data['DOB']?
    dob = for date_detail in alert.data.date_details or []
      # New Anansi date structure (introduced `date_type` field)
      if date_detail.date_type? and date_detail.date_type is "Date of Birth"
        "#{date_detail.day or ''} #{date_detail.month or ''} #{date_detail.year or ''}"
      # Old Anansi date structure (pure string)
      else if date_detail.indexOf?('Date of Birth') > -1
        date_detail.substr(14)
      else
        continue
    return dob.join(', ').trim()

  $scope.getCountry = (id) ->
    for country in $scope.countries
      if country.id is id
        return country.name or ""
    return ""

  $scope.getCountries = (alert) ->
    return alert.data['Country'] if alert.data['Country']?
    return alert.data['Target Nation'] if alert.data['Target Nation']?
    countries = for country in alert.data.country or []
      if country.name?
        country.name
      else
        country

    # Remove duplicates in the `countries` array
    # It does this by checking for the index of the first occurence of a
    # country [name], and if it matches the current country, it is unique.
    # If it doesn't match (false), it means there's already a country on
    # an earlier index (i.e. it is not unique, and should be filtered out).
    removeDuplicates = (countries) ->
      countries.filter((country, i, self) ->
        return self.indexOf(country) is i
      )

    return removeDuplicates(countries).join(', ')
